import React from "react";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";

import MainContainer from "pages/_components/MainContainer";
import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionSign } from "pages/_components/TransactionCard";

import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import { actions as checkActions } from "reducers/checks";
import { bool } from "prop-types";
import CheckbookSummary from "./components/CheckbookSummary";
import { useCheckbookTransaction } from "./hooks/useCheckbookTransaction";
import { TransactionHeader } from "./components/TransactionHeaderCheckbook";

const PendingUserSignaturesPage = ({ isDesktop }) => {
    const { isLoading, transaction, showSignButton, dispatch, isBackoffice } = useCheckbookTransaction();
    const { idTransaction, data } = transaction;

    const handleSignTransaction = () => {
        dispatch(checkActions.setNewCheckbookRequest({ ...data, idTransaction }));
        dispatch(routerActions.push("/checks/summaryCheckbookForm"));
    };

    const handleClickDownload = () => {};

    const handleRedirection = () => {
        const route = isBackoffice
            ? `/backoffice/checks/pendingBackofficeApprove/${idTransaction}`
            : `/checks/pendingBackofficeApprove/${idTransaction}`;
        dispatch(routerActions.push(route, { transaction }));
    };
    // const renderMenuOption = () => (
    //     <>
    //         {isDesktop ? (
    //             <div className="toolbar-item download" key="exportList">
    //                 <Button
    //                     className="btn btn-outline"
    //                     image="images/figma/icon/download.svg"
    //                     label="global.download"
    //                     block={false}
    //                 />
    //             </div>
    //         ) : (
    //             <div className="toolbar-item download" key="exportList">
    //                 <Button className="btn" image="images/figma/icon/download.svg" block={false} />
    //             </div>
    //         )}
    //     </>
    // );
    return data?.isPendingBackofficeApproval ? (
        handleRedirection()
    ) : (
        <>
            {!isBackoffice && (
                <CustomProductHead
                    titleId="checks.create.title"
                    exportList="global.download"
                    handleClickDownload={handleClickDownload()}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id="checks.create.title" />
                    </div>
                </CustomProductHead>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container">
                    <TransactionCard transaction={transaction}>
                        <TransactionHeader
                            subTitle={`forms.transaction.ticket.status.${transaction.idTransactionStatus}`}
                        />
                        <div className="ticket">
                            <div className="ticket__wrapper">
                                <div className="ticket__header" style={{ marginBottom: isDesktop ? "-20px" : "0" }} />
                                <CheckbookSummary
                                    title="activities.request.checkbook.send"
                                    style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
                                />
                                <div className="ticket__body">
                                    <TransactionSign creationTime isSmall isDesktop={isDesktop} showMoreData />
                                </div>
                                <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                            </div>
                        </div>
                    </TransactionCard>
                    {!isBackoffice && (
                        <Row className="form-actions">
                            {showSignButton && (
                                <Col xs={12} md={6} mdOffset={3}>
                                    <CustomButton
                                        func={handleSignTransaction}
                                        text="forms.signTransaction.link"
                                        textType="I18N"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                            <Col xs={12} md={6} mdOffset={3}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn btn-primary"
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

PendingUserSignaturesPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default PendingUserSignaturesPage;
